// fetching
import { useEffect, useState } from "react";
import useFetch from "Hooks/useFetch";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
const Services = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const { t } = useTranslation();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData("services");
      setData(data?.services);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(true);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="flex flex-col gap-y-3 text-white uppercase">
      <p>{t("nav_services")}</p>

      <ul className="flex flex-col gap-y-2 text-sm capitalize">
        {data?.map(({ title, slug }, index) => (
          <Link
            className="hover:underline uppercase"
            to={`/serviceDetailes/${slug}`}
            key={index}
          >
            {title}
          </Link>
        ))}
      </ul>
    </div>
  );
};

export default Services;
